import { localDatabaseUrls } from "../backend/constants";
import { getAPI } from "../backend/commons";
import { getJWTToken } from "../shared/fetchWrapper/fetchWrapper";
import { getFileXlsx } from "../templates/CostUpload/FileReceiver";
import AlertManager from "../shared/Alert/Alert";

const downloadDCCostConsolidatedFile = async (batchId, status) => {
  const tokenInfo = await getJWTToken();
  if (!tokenInfo) {
    window.location.href = "/";
    return null;
  }

  if (!batchId) {
    AlertManager.error("Missing batch ID for report download.", { contactSupport: false });
    return null;
  }

  const apiUrl = `${localDatabaseUrls.baseURL}api/v1/dc-cost/download-consolidated/${status}/${encodeURIComponent(batchId)}`;

  try {
    const response = await getAPI(apiUrl, tokenInfo);

    if (!response || !response.ok) {
      const errorData = await response?.json?.().catch(() => ({}));
      throw new Error(errorData?.message || response?.statusText || "Unable to download report.");
    }

    const contentDisposition = response.headers?.get?.("content-disposition");
    let fileName = `dc-cost-consolidated-${status}-${batchId}.xlsx`;

    if (contentDisposition && contentDisposition.includes("filename=")) {
      const match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
      if (match && match[1]) {
        fileName = match[1].replace(/['"]/g, "");
      }
    }

    await getFileXlsx(fileName, response, `${status}-file`);
    return { fileName };
  } catch (error) {
    AlertManager.error(error?.message || "Unable to download report.", { contactSupport: false });
    return null;
  }
};

export const downloadDCCostAsgFile = async (batchId) => downloadDCCostConsolidatedFile(batchId, "approved");

export const downloadDCCostUnifiedFile = async (batchId) => downloadDCCostConsolidatedFile(batchId, "unified");

export const downloadDCCostApprovedCostFile = async (batchId) => {
  const tokenInfo = await getJWTToken();
  if (!tokenInfo) {
    window.location.href = "/";
    return null;
  }

  if (!batchId) {
    AlertManager.error("Missing batch ID for report download.", { contactSupport: false });
    return null;
  }

  const apiUrl = `${localDatabaseUrls.baseURL}api/v1/dc-cost/download-cost-file/consolidated/approved/${encodeURIComponent(batchId)}`;

  try {
    const response = await getAPI(apiUrl, tokenInfo);

    if (!response || !response.ok) {
      const errorData = await response?.json?.().catch(() => ({}));
      throw new Error(errorData?.message || response?.statusText || "Unable to download report.");
    }

    const contentDisposition = response.headers?.get?.("content-disposition");
    let fileName = `dc-cost-file-consolidated-approved-${batchId}.xlsx`;

    if (contentDisposition && contentDisposition.includes("filename=")) {
      const match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
      if (match && match[1]) {
        fileName = match[1].replace(/['"]/g, "");
      }
    }

    await getFileXlsx(fileName, response, "approved-file");
    return { fileName };
  } catch (error) {
    AlertManager.error(error?.message || "Unable to download report.", { contactSupport: false });
    return null;
  }
};

export const downloadDCCostDraftCostFile = async (batchId) => {
  const tokenInfo = await getJWTToken();
  if (!tokenInfo) {
    window.location.href = "/";
    return null;
  }

  if (!batchId) {
    AlertManager.error("Missing batch ID for report download.", { contactSupport: false });
    return null;
  }

  const apiUrl = `${localDatabaseUrls.baseURL}api/v1/dc-cost/download-cost-file/consolidated/draft/${encodeURIComponent(batchId)}`;

  try {
    const response = await getAPI(apiUrl, tokenInfo);

    if (!response || !response.ok) {
      const errorData = await response?.json?.().catch(() => ({}));
      throw new Error(errorData?.message || response?.statusText || "Unable to download report.");
    }

    const contentDisposition = response.headers?.get?.("content-disposition");
    let fileName = `dc-cost-file-consolidated-draft-${batchId}.xlsx`;

    if (contentDisposition && contentDisposition.includes("filename=")) {
      const match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
      if (match && match[1]) {
        fileName = match[1].replace(/['"]/g, "");
      }
    }

    await getFileXlsx(fileName, response, "draft-file");
    return { fileName };
  } catch (error) {
    AlertManager.error(error?.message || "Unable to download report.", { contactSupport: false });
    return null;
  }
};

export const downloadDCCostRejectedFile = async (batchId) => downloadDCCostConsolidatedFile(batchId, "excluded");

export const downloadDCCostDraftFile = async (batchId) => downloadDCCostConsolidatedFile(batchId, "draft");

export default downloadDCCostAsgFile;
